import { Injectable } from "@angular/core";

@Injectable({
  providedIn: 'root'
})
export class SessionStorageService {
  getToken() {
    return sessionStorage.getItem('accessToken');
  }

  getUser() {
    return JSON.parse(sessionStorage.getItem('userDetails') || '{}');
  }

  getCompanyData() {
    return JSON.parse(sessionStorage.getItem('app_session') || '{}');
  }

  logout() {
    sessionStorage.clear();
  }

  // Clear stored session and authentication tokens
  // to prevent expired token reuse after session timeout.
  clearSession(): void {
    sessionStorage.clear();
    localStorage.removeItem('token');
    localStorage.removeItem('refreshToken');

  }
}
